/*
  Solli's Icons: einheitliche Groesse und Rohdateien aus dem Vektorisierer.
  Gehoert zu snippets/sollis-icon.liquid. Jedes Solli's-Icon kommt dort mit data-sollis-fit an
  (Rohdateien zusaetzlich mit sollis-icon--raw, zu grosse Dateien mit data-sollis-src). Dieses Skript
  1. misst die tatsaechliche Zeichnung aus und setzt sie mittig auf eine einheitliche Groesse
     (Gruppe sollis-icon__fit), egal wie viel Rand die Datei hat,
  2. uebernimmt bei Rohdateien die Farben aus den Stilklassen, faerbt dunkle Flaechen in currentColor
     um, entfernt Metadaten und weisse Hintergrundflaechen und blendet sie erst danach ein.
  Groesse: GROESSE ist die laengste Seite in Einheiten von 24. Bei AUSGLEICH 'optisch' werden
  kompakte Motive (Kreise, Quadrate) etwas kleiner gesetzt als schmale, damit alle gleich schwer
  wirken (Flaechenmass OPTISCH). AUSGLEICH 'laenge' setzt nur die laengste Seite gleich.
  Icons in geschlossenen Menues oder Akkordeons werden erst eingepasst, wenn sie sichtbar werden.
*/
(function () {
  'use strict';
  if (window.__sollisIconRaw) return;
  window.__sollisIconRaw = true;

  var GROESSE = 20;
  var AUSGLEICH = 'optisch';
  var OPTISCH = 18;
  var NS = 'http://www.w3.org/2000/svg';
  var BLOB = 'M20.5 3.4c5.1.3 8.9 4.6 8.4 9.7-.4 4.6-3.9 8.3-8.5 9.2-3.3.7-6.7-.2-9.2-2.4-2.6-2.3-3.8-5.8-3-9.2C9.2 6.1 14.6 3.1 20.5 3.4z';
  var SEL = 'svg[data-sollis-fit], svg[data-sollis-src]';
  var DROP = 'metadata, title, desc, script, foreignObject, style, sollis-style';
  var PROPS = ['fill', 'fill-opacity', 'fill-rule', 'clip-rule', 'stroke', 'stroke-width', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'opacity', 'display'];
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var cache = {};
  var uid = 0;
  var io = null;

  function show(el) { el.style.visibility = ''; }

  function load(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    }
    return cache[url];
  }

  function rgb(v) {
    if (!v) return null;
    v = String(v).trim().toLowerCase();
    if (v === 'black') return [0, 0, 0];
    if (v === 'white') return [255, 255, 255];
    var m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/.exec(v);
    if (m) {
      var h = m[1];
      if (h.length === 3) h = h.charAt(0) + h.charAt(0) + h.charAt(1) + h.charAt(1) + h.charAt(2) + h.charAt(2);
      return [parseInt(h.substr(0, 2), 16), parseInt(h.substr(2, 2), 16), parseInt(h.substr(4, 2), 16)];
    }
    m = /^rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)/.exec(v);
    return m ? [+m[1], +m[2], +m[3]] : null;
  }
  function lum(c) { return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255; }

  // Stilregeln der Datei (.st0 { fill: #010101; }) als Attribute auf die Elemente uebertragen
  function applyCss(g, css) {
    css = css.replace(/\/\*[\s\S]*?\*\//g, '');
    var re = /([^{}]+)\{([^{}]*)\}/g, m;
    while ((m = re.exec(css))) {
      var decls = {};
      m[2].split(';').forEach(function (d) {
        var i = d.indexOf(':');
        if (i > 0) {
          var k = d.slice(0, i).trim().toLowerCase(), val = d.slice(i + 1).trim();
          if (PROPS.indexOf(k) > -1 && val) decls[k] = val;
        }
      });
      m[1].split(',').forEach(function (s) {
        s = s.trim();
        if (!s || s.charAt(0) === '@') return;
        var nodes;
        try { nodes = g.querySelectorAll(s); } catch (e) { return; }
        each(nodes, function (n) {
          Object.keys(decls).forEach(function (k) { n.setAttribute(k, decls[k]); });
        });
      });
    }
  }

  // Farben vereinheitlichen, Metadaten entfernen, IDs eindeutig machen
  function normalize(g) {
    each(g.querySelectorAll('style, sollis-style'), function (s) { applyCss(g, s.textContent || ''); });
    each(g.querySelectorAll(DROP), function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
    var all = g.querySelectorAll('*');
    var used = {};
    each(all, function (el) {
      each(el.attributes, function (a) {
        var re = /url\(\s*['"]?#([^'")\s]+)['"]?\s*\)/g, m;
        while ((m = re.exec(a.value))) used[m[1]] = true;
        if ((a.name === 'href' || a.name === 'xlink:href') && a.value.charAt(0) === '#') used[a.value.slice(1)] = true;
      });
    });
    var pre = 'sollis-ic' + (++uid) + '-';
    each(all, function (el) {
      if (el.id) {
        if (used[el.id]) el.id = pre + el.id; else el.removeAttribute('id');
      }
      each(Array.prototype.slice.call(el.attributes), function (a) {
        var v = a.value;
        var nv = v.replace(/url\(\s*(['"]?)#([^'")\s]+)\1\s*\)/g, function (s, q, id) { return used[id] ? 'url(#' + pre + id + ')' : s; });
        if ((a.name === 'href' || a.name === 'xlink:href') && v.charAt(0) === '#' && used[v.slice(1)]) nv = '#' + pre + v.slice(1);
        if (nv !== v) a.value = nv;
      });
      ['fill', 'stroke'].forEach(function (p) {
        var c = rgb(el.getAttribute(p));
        if (c && lum(c) < 0.5) el.setAttribute(p, 'currentColor');
        var sc = el.style ? rgb(el.style.getPropertyValue(p)) : null;
        if (sc && lum(sc) < 0.5) el.style.setProperty(p, 'currentColor');
      });
      el.removeAttribute('class');
    });
  }

  function box(n) {
    try {
      var b = n.getBBox();
      return b && b.width > 0 && b.height > 0 ? b : null;
    } catch (e) { return null; }
  }

  // Leere Bild-Elemente (Reste aus Illustrator) zaehlen sonst beim Ausmessen mit
  function prune(g) {
    each(g.querySelectorAll('image'), function (n) {
      if (!n.getAttribute('href') && !n.getAttribute('xlink:href') && !n.getAttributeNS('http://www.w3.org/1999/xlink', 'href')) {
        if (n.parentNode) n.parentNode.removeChild(n);
      }
    });
  }

  function place(fg, x, y, w, h, modus) {
    var s = GROESSE / Math.max(w, h);
    if ((modus || AUSGLEICH) === 'optisch') s = Math.min(s, OPTISCH / Math.sqrt(w * h));
    var r = function (n) { return Math.round(n * 10000) / 10000; };
    fg.setAttribute('transform', 'translate(12 12) scale(' + r(s) + ') translate(' + r(-(x + w / 2)) + ' ' + r(-(y + h / 2)) + ')');
  }

  // Zeichnung auf einheitliche Groesse einpassen; false, solange sie nicht messbar ist
  function fit(el) {
    var fg = el.querySelector('g.sollis-icon__fit');
    var g = fg && fg.querySelector('g.sollis-icon__g');
    if (!g) { el.removeAttribute('data-sollis-fit'); show(el); return true; }
    var raw = el.classList.contains('sollis-icon--raw');
    if (!el.__sollisNorm) {
      if (raw) normalize(g);
      prune(g);
      el.__sollisNorm = true;
    }
    var bb = box(g);
    if (!bb) return false;
    if (raw) {
      var area = bb.width * bb.height, cut = false;
      each(g.querySelectorAll('path, rect, polygon, circle, ellipse'), function (sh) {
        var c = rgb(sh.getAttribute('fill')) || (sh.style ? rgb(sh.style.getPropertyValue('fill')) : null);
        if (!c || lum(c) < 0.9) return;
        var b = box(sh);
        if (b && b.width * b.height >= 0.8 * area) { sh.parentNode.removeChild(sh); cut = true; }
      });
      if (cut) { bb = box(g); if (!bb) return false; }
    }
    place(fg, bb.x, bb.y, bb.width, bb.height);
    el.removeAttribute('data-sollis-fit');
    show(el);
    return true;
  }

  function tryFit(el, n) {
    if (fit(el)) { if (io) io.unobserve(el); return; }
    if (n < 20) { requestAnimationFrame(function () { tryFit(el, n + 1); }); return; }
    show(el);
  }

  function parse(text) {
    if (!text || text.indexOf('<svg') < 0) return null;
    try {
      var doc = new DOMParser().parseFromString(text, 'image/svg+xml');
      var root = doc.documentElement;
      if (!root || root.localName !== 'svg' || doc.getElementsByTagName('parsererror').length) return null;
      return root;
    } catch (e) { return null; }
  }

  function mk(tag) { return document.createElementNS(NS, tag); }

  // Platzhalter (Datei zu gross zum Einbetten) mit der nachgeladenen Datei fuellen
  function build(el, root) {
    var vb = root.getAttribute('viewBox');
    if (!vb) vb = '0 0 ' + (parseFloat(root.getAttribute('width')) || 24) + ' ' + (parseFloat(root.getAttribute('height')) || 24);
    var hl = el.getAttribute('data-sollis-variant') === 'hl';
    var zf = parseFloat(el.getAttribute('data-sollis-zoom')) || 1.1;
    while (el.firstChild) el.removeChild(el.firstChild);
    el.setAttribute('viewBox', hl ? '0 0 32 32' : '0 0 24 24');
    el.setAttribute('fill', 'currentColor');
    el.removeAttribute('stroke');
    el.removeAttribute('stroke-width');
    if (hl) {
      el.setAttribute('class', (el.getAttribute('class') || '') + ' sollis-icon--hl');
      var blob = mk('path');
      blob.setAttribute('fill', '#4FBAD7');
      blob.setAttribute('fill-opacity', '0.28');
      blob.setAttribute('d', BLOB);
      el.appendChild(blob);
    }
    var t = mk('g');
    t.setAttribute('transform', (hl ? 'translate(16 16)' : 'translate(12 12)') + ' scale(' + zf + ') translate(-12 -12)');
    var fg = mk('g');
    fg.setAttribute('class', 'sollis-icon__fit');
    var v = vb.replace(/,/g, ' ').trim().split(/\s+/).map(parseFloat);
    if (v.length === 4 && v[2] > 0 && v[3] > 0) place(fg, v[0], v[1], v[2], v[3], 'laenge');
    var g = mk('g');
    g.setAttribute('class', 'sollis-icon__g');
    each(root.childNodes, function (n) { g.appendChild(document.importNode(n, true)); });
    fg.appendChild(g);
    t.appendChild(fg);
    el.appendChild(t);
    el.setAttribute('data-sollis-fit', '');
  }

  function process(el) {
    if (el.__sollisBusy) return;
    if (el.hasAttribute('data-sollis-src')) {
      el.__sollisBusy = true;
      var url = el.getAttribute('data-sollis-src');
      el.removeAttribute('data-sollis-src');
      load(url).then(function (text) {
        el.__sollisBusy = false;
        var root = parse(text);
        if (!root) { show(el); if (io) io.unobserve(el); return; }
        build(el, root);
        tryFit(el, 0);
      });
      return;
    }
    if (el.hasAttribute('data-sollis-fit')) tryFit(el, 0);
  }

  function watch(el) {
    if (el.__sollisSeen) return;
    el.__sollisSeen = true;
    if (io) io.observe(el); else process(el);
  }

  function scan(root) {
    if (root.nodeType === 1 && root.matches && root.matches(SEL)) watch(root);
    if (root.querySelectorAll) each(root.querySelectorAll(SEL), watch);
  }

  function start() {
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) process(en.target); });
      }, { rootMargin: '200px 0px' });
    }
    scan(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          each(m.addedNodes, function (n) { if (n.nodeType === 1) scan(n); });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
